
import React from "react";
import { ForecastAccuracyItem } from "./types";

interface ImprovementsPanelProps {
  overForecastedItems: ForecastAccuracyItem[];
  underForecastedItems: ForecastAccuracyItem[];
  getFilterLabel: () => string;
}

export const ImprovementsPanel: React.FC<ImprovementsPanelProps> = ({
  overForecastedItems,
  underForecastedItems,
  getFilterLabel
}) => {
  return (
    <div className="bg-secondary/80 p-4 rounded-lg border border-primary/20 mb-4">
      <h3 className="text-primary-light font-medium">
        Forecast Accuracy Improvements Needed
        <span className="text-purple-300 ml-1">{getFilterLabel()}</span>
      </h3>
      
      <div className="mt-2 p-3 bg-secondary/50 border border-primary/30 rounded">
        <p className="text-sm mb-2">
          <span className="text-purple-300 font-medium">Over-forecasted: </span>
          {overForecastedItems.length > 0 ? (
            overForecastedItems.map((item, index) => (
              <span key={item.name}>
                {item.name} <span className="text-yellow-300">({item.accuracy.toFixed(2)}%)</span>
                {index < overForecastedItems.length - 1 ? ', ' : ''}
              </span>
            ))
          ) : (
            <span className="text-gray-400">None</span>
          )}
        </p>
        <p className="text-sm">
          <span className="text-purple-300 font-medium">Under-forecasted: </span>
          {underForecastedItems.length > 0 ? (
            underForecastedItems.map((item, index) => (
              <span key={item.name}>
                {item.name} <span className="text-yellow-300">({item.accuracy.toFixed(2)}%)</span>
                {index < underForecastedItems.length - 1 ? ', ' : ''}
              </span>
            ))
          ) : (
            <span className="text-gray-400">None</span>
          )}
        </p>
      </div>
    </div>
  );
};
